export default "__VITE_ASSET__CXMPsbB8__"